
export const cleanPath = (path) => {
    if (!path) return '';
    return path.startsWith('/') ? path.substring(1) : path;
};
